import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function Footer() {
  return (
    <footer className=" text-light py-1 mt-auto w-100"  style={{
        width: "100%",
        backgroundColor: "#d9e6f2"}}>
      <div className="container text-center">
        <small style={{color:"black"}}>
          &copy; {new Date().getFullYear()} ALL INDIA INSTITUTE OF MEDICAL SCIENCES NAGPUR. All rights reserved.
        </small>
      </div>
    </footer>
  );
}

export default Footer;
